import React from "react";
import { Dialog } from "@mui/material";
import SupportChatConversation from "./SupportChatConversation";

export default function SupportChatConversationDialog({
  conversationId,
  onClose,
}) {
  return (
    <Dialog
      open={!!conversationId}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: { height: "85vh" } }}
      aria-label="Support chat conversation"
    >
      {conversationId && (
        <SupportChatConversation
          conversationId={conversationId}
          onClose={onClose}
        />
      )}
    </Dialog>
  );
}
